import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardTemplateDb } from '../redux/cardTemplateDbSlice';

const useOneCardTemplateValue = (id: string | undefined): CardTemplateDb | undefined => {
  const cardTemplateDb = useSelector((state: RootState) => state.cardTemplateDb);
  const value = id ? cardTemplateDb.cardTemplates[id] : undefined;

  return value;
}

export default useOneCardTemplateValue;
